export default __webpack_public_path__ + "static/img-1-50c8dff7d5486bac9e241f524afde5a0.png";